export default __webpack_public_path__ + "55d15ce96f0d35f2814c005bc5fd5223.png";